// extracted by mini-css-extract-plugin
module.exports = {"container":"AppStoreSubscription_container__HE16K"};